module.exports = __webpack_public_path__ + "static/fonts/notokr-light.251f03d.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/views/surveys/sydney/font/notokr-light.woff2
// module id = LZqC
// module chunks = 0